import React from 'react';
import styles from './BusinessClassSurvey.less';
import { BusinessClassSurveyProps } from './types';
import { BusinessClassFreeformSurvey } from './BusinessClassFreeformSurvey';
import { BusinessClassListSurvey } from './BusinessClassListSurvey';

interface Props extends BusinessClassSurveyProps {
  showFreeform: boolean;
}

export function BusinessClassSurvey(props: Props) {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {props.showFreeform ? (
          <BusinessClassFreeformSurvey {...props} />
        ) : (
          <BusinessClassListSurvey {...props} />
        )}
      </div>
    </div>
  );
}
